import { API } from '../Api';

// Gamification "Ca đào" — điểm game (KHÔNG phải tiền, không nạp/donate/rút).
// Máy đào: 5 Ca/giờ, trần 15 (3h). Điểm danh hàng ngày +5 Ca.
const base = '/v1/payment-service/gamification';

export interface MinerStatus {
  minedCa: number; // số dư Ca đào
  minerActive: boolean;
  pending: number; // Ca đang chờ thu
  capped: boolean; // đã đầy trần, cần vào thu
  ratePerHour: number;
  capCa: number;
  secondsUntilCap: number; // còn bao lâu đầy
  canCheckInToday: boolean;
  checkInStreak: number;
  dailyReward: number;
  /** Người dùng đã TẮT nhắc nhiệm vụ hay chưa. */
  questReminderOff?: boolean;
}

export interface GamificationActionResult {
  success: boolean;
  message: string;
  gained: number; // Ca vừa nhận
  minedCa: number; // số dư sau
}

export const getMinerStatus = () =>
  API.get<MinerStatus>(`${base}/miner/status`).then((r) => r.data);

export const collectMiner = () =>
  API.post<GamificationActionResult>(`${base}/miner/collect`).then((r) => r.data);

// Bật/tắt nhắc làm nhiệm vụ (thông báo tối đa 1 lần/ngày, chỉ gửi khi chưa làm xong).
export const setQuestReminder = (enabled: boolean) =>
  API.post<GamificationActionResult>(
    `${base}/quest-reminder?enabled=${enabled}`
  ).then((r) => r.data);

export const dailyCheckIn = () =>
  API.post<GamificationActionResult>(`${base}/checkin`).then((r) => r.data);

export interface QuestStatus {
  key: string; // CHECKIN | LIKE_POST | SHARE_POST
  label: string;
  target: number;
  current: number;
  reward: number;
  done: boolean;
}

export const getQuests = () =>
  API.get<QuestStatus[]>(`${base}/quests`).then((r) => r.data);

// Blind Box theo HẠNG — mở bằng Ca đào (không mua được bằng tiền → không phải cờ bạc).
export interface BlindBoxOdd {
  label: string;
  percent: number;
}
export interface BlindBoxTier {
  key: string; // basic | rare | vip
  label: string;
  price: number;
  caReward: number;
  odds: BlindBoxOdd[];
}
export interface BlindBoxInfo {
  minedCa: number;
  cosmeticDaysMin: number;
  cosmeticDaysMax: number;
  tiers: BlindBoxTier[];
}

export interface OpenBoxResult {
  success: boolean;
  message: string;
  kind: string; // "Miss" | "Ca" | "Item"
  tier: string; // basic|rare|vip (chọn hiệu ứng)
  rarity?: string;
  itemName?: string;
  itemCode?: string;
  itemType?: string; // Nametag | AvatarEffect
  style?: string;
  mintNumber?: number | null;
  expiresInDays?: number | null; // cosmetic ngắn hạn
  caReward: number;
  minedCaAfter: number;
}

export const getBlindBox = () =>
  API.get<BlindBoxInfo>(`${base}/blindbox`).then((r) => r.data);

export const openBlindBox = (tier: string) =>
  API.post<OpenBoxResult>(`${base}/blindbox/open?tier=${encodeURIComponent(tier)}`).then((r) => r.data);

// Chuỗi Sáng Tạo — nhiệm vụ sáng tạo theo TUẦN (3 bậc, đếm ngược). Thưởng bằng Ca đào.
export interface CreationTierStatus {
  tier: number;
  label: string; // Dễ | Vừa | Khó
  contentTarget: number;
  engageTarget: number;
  reward: number;
  done: boolean;
  rewarded: boolean;
}
export interface CreationStatus {
  periodKey: string;
  secondsLeft: number; // đếm ngược tới cuối tuần
  contentCount: number;
  engagementCount: number;
  currentStreak: number; // GĐ2: chuỗi tuần liên tiếp
  streakMilestone: number;
  streakBonus: number;
  levelIndex: number; // GĐ3: 0 Đồng,1 Bạc,2 Vàng,3 Bạch Kim
  levelName: string;
  levelScore: number;
  levelNextThreshold: number;
  tiers: CreationTierStatus[];
}

export const getCreationStatus = () =>
  API.get<CreationStatus>(`${base}/creation/status`).then((r) => r.data);
